module.exports = __webpack_public_path__ + "img/gauge_back.f716ea44.png";